<template>
    <div class="semaforo-vermelho"></div>
</template>

<script>
export default {
    name: 'SemaforoVermelho',
}
</script>

<style scoped>
.semaforo-vermelho {
    background: #d11e1d;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    position: relative;
}
.semaforo-vermelho:after {
    content: '';
    height: 18px;
    border-left: 3px solid #fff;
    border-radius: 10px;
    position: absolute;
    transform: rotate(45deg);
    left: 11.5px;
    top: 4px;
}

.semaforo-vermelho:before {
    content: '';
    border-radius: 10px;
    height: 18px;
    border-left: 3px solid #fff;
    position: absolute;
    transform: rotate(-45deg);
    left: 11.5px;
    top: 4px;
}
</style>